import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="event-history-search"
export default class extends Controller {
  static targets = ["tableRow"]

    search(event) {
        const query = event.currentTarget.value.toLowerCase()

        this.tableRowTargets.forEach(row => {
            const match = this._matches(row, query)
            row.classList.toggle("hidden", query.length > 0 && !match)
        })
    }

    _matches(element, query) {
        if (element.children.length === 0) {
            return element.innerText.toLowerCase().includes(query)
        }

        for (const child of element.children) {
            if (this._matches(child, query)) return true
        }

        return false
    }
}
